require('select2');
require('sortablejs');

const lt = require('select2/src/js/select2/i18n/lt');
const lang = document.documentElement.getAttribute('lang');

const select2AjaxInputSelector = "[data-input='select2_ajax']";
const select2TagsInputSelector = "[data-input='select2_tags']";
const select2inputSelector = "[data-input='select2']";

class CmsSelect2Ajax {
    constructor(input) {
        var c = {
            language: lang === 'lt' ? lt: null,
            width: '90%',
            minimumInputLength: 2,
            templateSelection: function(repo) {
                return repo.title || repo.text || repo.id;
            },
            templateResult: function (repo) {
                return repo.title || repo.text || repo.id;
            },
            ajax: {
                delay: 500,
                dataType: "json",
                data: function(params) {
                    var filters = {
                        q: params.term
                    };

                    if(c.depends_on){
                        $.each(c.depends_on, function (index, fieldId) {
                            filters[fieldId] = $("#" + fieldId).val();
                        });
                    }

                    return filters
                },
                processResults: function(data, params) {
                    return { results: data };
                }
            },
        };
        $.extend(c, $(input).data('options'));
        c.ajax.url = c.url;
        if(c.dataType) {
            c.ajax.dataType = c.dataType;
        }

        if(typeof c.dropdownParent === "string"){
            c.dropdownParent = $(c.dropdownParent)
        }

        $(input).select2(c)
            //isjungiam atidaryma po clear
            .on('select2:unselecting', function() {
                $(this).data('unselecting', true);
            }).on('select2:opening', function(e) {
            if ($(this).data('unselecting')) {
                $(this).removeData('unselecting');
                e.preventDefault();
            }
        });

        if(c.sortable){
            $(input).select2_sortable();
        }
        $(input).data('inited', true);
    }
}
class CmsSelect2Tags {
    constructor(input) {
        var c = {
            language: lang === 'lt' ? lt: null,
            width: '100%',
            tags: true
        };
        $.extend(c, $(input).data('options'));

        if(c.url){
            c.ajax = {
                url: c.url,
                delay: 500,
                dataType: "json",
                data: function(params) {
                    var filters = {
                        q: params.term
                    };

                    if(c.depends_on){
                        $.each(c.depends_on, function (index, fieldId) {
                            filters[fieldId] = $("#" + fieldId).val();
                        });
                    }

                    return filters
                },
                processResults: function(data, params) {
                    return { results: data };
                }
            };
            c.templateResult = function (repo) {
                return repo.title || repo.text || repo.id;
            };
            c.templateSelection = function(repo) {
                return repo.title || repo.text || repo.id;
            };

            if(c.dataType) {
                c.ajax.dataType = c.dataType;
            }
        }

        if(typeof c.dropdownParent === "string"){
            c.dropdownParent = $(c.dropdownParent)
        }

        $(input).select2(c)
            //isjungiam atidaryma po clear
            .on('select2:unselecting', function() {
                $(this).data('unselecting', true);
            }).on('select2:opening', function(e) {
            if ($(this).data('unselecting')) {
                $(this).removeData('unselecting');
                e.preventDefault();
            }
        });
        if(c.sortable){
            $(input).select2_sortable();
        }

        if(c.data_url){
            CmsSelect2.load_selec2_data(input, c);
        }

        $(input).data('inited', true);
    }
}
class CmsSelect2{

    static init($context = null){

        $.fn.extend({
            select2_sortable: function(){
                let $select = $(this);
                let $ul = $select.next(".select2-container").find('.select2-selection__rendered');
                new Sortable($ul[0], {
                    animation: 150,
                    filter: '.select2-search__field, .select2-search--inline',
                    direction: 'vertical',
                    onEnd: function (evt){
                        $( $ul.find(".select2-selection__choice").get().reverse() ).each(function() {
                            let title = $(this).attr("title");
                            let option = $select.find( "option:contains(" + title + ")" );
                            $select.prepend(option);
                        });
                    }
                });
            }
        });

        CmsSelect2.init_select2($context);
        CmsSelect2.init_select2_ajax($context);
        CmsSelect2.init_select2_tags($context);
    }

    /**
     * @deprecated use init instead
     */
    static init_select2_all(){
        CmsSelect2.init();
    }

    static init_select2_ajax($context = null){

        let $inputs = $context ? $context.find(select2AjaxInputSelector) : $(select2AjaxInputSelector);

        $inputs.each(function (index, input) {
            if(input.dataset.select_ajax_instance) return;
            input.dataset.select_ajax_instance = new CmsSelect2Ajax(input)
        });
    }

    static init_select2_tags($context = null){

        let $inputs = $context ? $context.find(select2TagsInputSelector) : $(select2TagsInputSelector);

        $inputs.each(function (index, input) {
            if(input.dataset.select_tags_instance) return;
            input.dataset.select_tags_instance = new CmsSelect2Tags(input)
        });
    }

    static init_select2($context = null){
        let that = this;

        let $inputs = $context ? $context.find(select2inputSelector) : $(select2inputSelector);
        $inputs.each(function (index, input) {
            if($(input).data('inited')) {
                return;
            }

            var c = {
                language: lang === 'lt' ? lt: null,
            };
            $.extend(c, $(input).data('options'));
            if(c.sortable){
                var values = $(input).data('value');
                if(values && Array.isArray(values)){
                    for(var v in values.reverse()){
                        var $option = $(input).find("option[value='"+values[v] +"']");

                        $(input).prepend($option);
                    }
                }
            }

            if(typeof c.dropdownParent === "string"){
                c.dropdownParent = $(c.dropdownParent)
            }

            $(input).select2(c)
                //isjungiam atidaryma po clear
                .on('select2:unselecting', function() {
                    $(this).data('unselecting', true);
                }).on('select2:opening', function(e) {
                if ($(this).data('unselecting')) {
                    $(this).removeData('unselecting');
                    e.preventDefault();
                }
            });
            if(c.sortable){
                $(input).select2_sortable();
            }
            if(c.data_url){
                that.load_selec2_data(input, c);
            }
            $(input).data('inited', true);

        });
    }
    static load_selec2_data(input, c) {
        var $input = $(input);
        function reloadData(selectedValues, firstTime){
            if(selectedValues instanceof Array){
                selectedValues = selectedValues.map(function(v) {
                    return parseInt(v);
                });
            }else if(selectedValues){
                selectedValues = [selectedValues]
            }else{
                selectedValues = [];
            }

            var canLoadData = true;
            if(c.required_dependencies){
                $.each(c.required_dependencies, function (index, fieldId) {
                    var v = $("#" + fieldId).val();
                    if(v instanceof Array){
                        if(!v.length){
                            canLoadData = false;
                        }
                    }else{
                        if(!v){
                            canLoadData = false;
                        }
                    }
                });
            }

            if(!canLoadData){
                $input
                    .val('')
                    .prop("disabled", true);
                return;
            }

            var filters = {};
            if(c.depends_on){
                $.each(c.depends_on, function (index, fieldId) {
                    filters[fieldId] = $("#" + fieldId).val();
                });
            }

            $input.prop("disabled", true);
            $.ajax({
                url: c.data_url,
                data: filters
            }).done(function (data) {
                $input.html('<option style="display: none"></option>');
                $.each(data, function(index, value){

                    if(value.children && value.children.length){
                        var $optgroup = $('<optgroup label="' + value.title+ '"></optgroup>');
                        $input.append($optgroup);
                        $.each(value.children, function(c_index, c_value){
                            var selected = selectedValues.indexOf(c_value.id) > -1;
                            var option = new Option(c_value.title, c_value.id, false, selected);
                            $optgroup.append(option);
                        });
                    }else{
                        var selected = selectedValues.indexOf(value.id) > -1;
                        var option = new Option(value.title, value.id, false, selected);
                        $input.append(option);
                    }
                });

                if(firstTime && $input.data('select2').options.options.tags){
                    //for tags, create new inputs for non existing values
                    for (var i in selectedValues){
                        var tag = selectedValues[i];
                        if(!$input.find("option[value='" + tag + "']").length){
                            var tagOption = new Option(tag, tag, false, true);
                            $input.append(tagOption);
                        }
                    }
                }

                $input.prop("disabled", false);
            })
        }

        var currentValue = $input.val();
        if(
            Array.isArray(currentValue) && currentValue.length === 0
            ||
            !currentValue
        ){
            currentValue = $input.data('value');
        }

        reloadData(currentValue, true);

        if(c.depends_on){
            $.each(c.depends_on, function (index, fieldId) {
                $("#" + fieldId).on('change', function () {
                    reloadData($input.val(), false)
                })
            });
        }
    }
}

CmsSelect2.init_select2_all();

export default CmsSelect2;